export const membershipStateLabels = Object.freeze({
    active: '활성',
    expired: '만료',
    refunded: '환불',
});

export const membershipStateOptions = Object.freeze(Object.entries(membershipStateLabels));

export const membershipStateLabel = (state) => membershipStateLabels[state] || state;

export const membershipSearchOptions = Object.freeze([
    { id: 1, title: '휴대번호', value: 'phone' },
    { id: 2, title: '닉네임', value: 'nickname' },
    { id: 3, title: '이름', value: 'name' },
    { id: 4, title: '모임명', value: 'gathering' },
    { id: 5, title: '결제 ID', value: 'pay_id' },
]);

export const membershipAdminLinks = (item, publicUrl = '') => ({
    gathering: `${publicUrl}/gathering/detail/${item.gathering_id}`,
});
